import { Button } from "@chakra-ui/react";
import {
  IconPerson,
  IconOnline,
  IconTelephone,
  IconEmail,
} from "../../styles/icons";
import BookingRequestModal from "../booking/initiate-booking/BookingRequestModal";
import { useMemo, useState } from "react";
import LogInModal from "../authentication/LogInModal";
import { useSelector } from "react-redux";
import { IsMobileView } from "../utilities/helpers";

export const ViewSectionSessionType = (props) => {
  const { profile } = props;
  const { sessionTypes, userId, profileId, fullname, practitionerType } =
    profile;
  const loggedIn = useSelector((state) => state.user.JWTToken);
  const [showLoginModal, setShowLoginModal] = useState(false);

  // Mobile View
  const mobileView = IsMobileView();
  const user = useSelector((state) => state.user.userDetails);

  const [showBookingRequestModal, setShowBookingRequestModal] = useState(false);

  const renderIcon = (type) => {
    if (!type) return null;
    if (type.includes("person")) return <IconPerson />;
    if (type.includes("line")) return <IconOnline />;
    if (type.includes("phone")) return <IconTelephone />;
    if (type.includes("email")) return <IconEmail />;
  };

  const isSelf = useMemo(() => !!(user && user.id === userId), [user, userId]);

  // Render
  return (
    <>
      {showBookingRequestModal && (
        <BookingRequestModal
          show={showBookingRequestModal}
          close={() => setShowBookingRequestModal(false)}
          practitionerId={userId}
          profileId={profileId}
          practitionerType={practitionerType}
          practitionerName={fullname}
        />
      )}
      {showLoginModal && (
        <LogInModal
          onCloseModal={(success) => {
            setShowBookingRequestModal(success);
            setShowLoginModal(false);
          }}
          title={`Please sign up or log in to contact ${fullname}`}
          therapistName={fullname}
          bookingRequest
          signUpChoice="bookingRequest"
          noRedirect
        />
      )}

      <div className="flex w-full flex-col gap-5 p-[20px_30px_30px_30px]">
        <p className="font-bold text-brand-text">Type of sessions available</p>
        <div className="flex flex-wrap gap-2">
          {sessionTypes.map((sType) => (
            <div
              key={sType.value}
              className="rounded-full bg-gray-100 flex items-center px-4 py-2.5 gap-2"
            >
              {renderIcon(sType.label)}
              <p className="font-bold text-sm">{sType.label}</p>
            </div>
          ))}
        </div>
        {!mobileView && !isSelf && (
          <>
            <div className="w-full border-t" />
            <div className="w-full">
              <Button
                id="make-contact-button-5"
                width="100%"
                height="52px"
                onClick={() =>
                  loggedIn
                    ? setShowBookingRequestModal(true)
                    : setShowLoginModal(true)
                }
              >
                Make contact
              </Button>
            </div>
          </>
        )}
      </div>
    </>
  );
};
